// extracted by mini-css-extract-plugin
module.exports = {"header_logo":"HeaderLogo__header_logo___2PbtZ"};